<template>
  <div>
    <ModosWebRepeaterComponent
      v-model="formularios"
      :item-default="formularioDefault"
      :minimo-itens="0"
      button-text="Vincular"
      @enviar="salvar"
    >
      <template #item="{ item, itemKey }">
        <div class="mb-3">
          <div v-if="item.tecnicoManual">
            <h6 class="tecnico-dados-titulo">
              Dados do Técnico
            </h6>

            <SGPFormInputComponent
              v-model="item.dados_tecnico_sem_cadastro"
              type="textarea"
              rows="4"
              :name="`dados_tecnico_sem_cadastro_${itemKey}`"
              placeholder="Informe os dados do técnico: nome, provedor, RG, CPF, telefone e outros dados relevantes"
              data-vv-as="Dados do técnico"
              v-validate="'required'"
              :error="validationErrors.first(`dados_tecnico_sem_cadastro_${itemKey}`)"
            />
          </div>

          <div v-else>
            <SGPFormAutocompleteComponent
              v-model="item.ctrl_tecnico_id"
              :listaDeOptions="listaDeTecnicos"
              optionLabel="nome"
              optionValue="id"
              placeholder="Técnico"
              :name="`ctrl_tecnico_id_${itemKey}`"
              data-vv-as="Técnico"
              @change="buscarDadosTecnico($event, item)"
              v-validate="'required'"
              :error="validationErrors.first(`ctrl_tecnico_id_${itemKey}`)"
            />

            <div
              v-if="item.ctrlTecnico"
              class="card bg-light mt-3 mb-3"
            >
              <div class="card-body py-2 tecnico-card-body">
                <div class="row">
                  <div class="col-md-6">
                    <strong>Provedor:</strong>
                    {{ item.ctrlTecnico?.ctrl_provedor?.nome }}
                  </div>

                  <div class="col-md-6">
                    <strong>Nome Completo:</strong>
                    {{ item.ctrlTecnico.nome }}
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <strong>RG:</strong>
                    {{ item.ctrlTecnico.rg }}
                  </div>

                  <div class="col-md-6">
                    <strong>CPF:</strong>
                    {{ item.ctrlTecnico.cpf }}
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <strong>Telefone:</strong>
                    {{ item.ctrlTecnico.telefone }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <SGPFormInputComponent
            v-model="item.observacao"
            type="textarea"
            rows="3"
            :name="`observacao_${itemKey}`"
            placeholder="Observação"
          />
        </div>

        <button
          v-if="!item.tecnicoManual"
          type="button"
          class="tecnico-opcao-trigger tecnico-manual-trigger mt-3"
          @click="informarTecnicoManual(item)"
        >
          <span class="tecnico-opcao-icon tecnico-manual-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <circle cx="9" cy="7" r="4" />
              <path d="M2.5 21v-2a6.5 6.5 0 0 1 11.5-4.2" />
              <path d="m15 19 2.5-.5 4-4a1.8 1.8 0 0 0-2.5-2.5l-4 4L15 19Z" />
            </svg>
          </span>

          <span class="tecnico-opcao-text">
            <strong>Não encontrou o técnico?</strong>
            <small>Informe os dados de um técnico não cadastrado.</small>
          </span>

          <span class="tecnico-opcao-chevron" aria-hidden="true">›</span>
        </button>

        <button
          v-else
          type="button"
          class="tecnico-opcao-trigger tecnico-cadastrado-trigger mt-3"
          @click="selecionarTecnicoCadastrado(item)"
        >
          <span class="tecnico-opcao-icon tecnico-cadastrado-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <circle cx="9" cy="7" r="4" />
              <path d="M2.5 21v-2a6.5 6.5 0 0 1 13 0v2" />
              <path d="m15 14 2.5 2.5L22 12" />
            </svg>
          </span>

          <span class="tecnico-opcao-text">
            <strong>Selecionar técnico cadastrado</strong>
            <small>Escolha um técnico já registrado no sistema.</small>
          </span>

          <span class="tecnico-opcao-chevron" aria-hidden="true">›</span>
        </button>
      </template>
    </ModosWebRepeaterComponent>

    <SGPLoadingComponent
      v-if="loadingCtrlTecnicos || loadingFichaTecnica"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

const FORMULARIO_DEFAULT = {
  ctrl_tecnico_id: null,
  dados_tecnico_sem_cadastro: '',
  tecnicoManual: false,
  observacao: '',
  ctrlTecnico: null
}

export default {
  name: 'VincularTecnicosComponent',

  props: {
    pcoWorkflowId: {
      type: Number,
      required: true
    },
    ctrlTarefaId: {
      type: Number,
      required: true
    },
  },

  data() {
    return {
      formularios: [],
      formularioDefault: FORMULARIO_DEFAULT
    }
  },

  async created() {
    await Promise.all([
      this.listarTecnicos(),
      this.carregarTecnicosVinculados()
    ])
  },

  methods: {
    ...mapActions('ctrlTecnicos', [
      'listarTecnicos'
    ]),

    ...mapActions('fichaTecnicaWorkflow', [
      'vincularTecnicos',
      'listarTecnicosPorWorkflow'
    ]),

    ...mapActions('fichaTecnicaWorkflow', [
      'buscarDadosFichaTecnicaTarefa',
      'buscarHistoricoTicket'
    ]),

    async carregarTecnicosVinculados() {
      try {
        const tecnicos = await this.listarTecnicosPorWorkflow(
          this.pcoWorkflowId
        )

        if (!tecnicos?.length) {
          this.formularios = [
            { ...this.formularioDefault }
          ]

          return
        }

        this.formularios = tecnicos.map(item => ({
          id: item.id,
          ctrl_tecnico_id: item.ctrl_tecnico_id || null,
          dados_tecnico_sem_cadastro: item.dados_tecnico_sem_cadastro || '',
          tecnicoManual: !item.ctrl_tecnico_id && !!item.dados_tecnico_sem_cadastro,
          observacao: item.observacao || '',
          ctrlTecnico: item.ctrl_tecnico
        }))
      } catch (error) {
        this.formularios = [
          { ...this.formularioDefault }
        ]
      }
    },

    async salvar(lista) {
      const valido =
        await this.$validator.validateAll()

      if (!valido) {
        return
      }

      const listaTecnicos = lista.map(item => {
        const tecnicoManual = item.tecnicoManual
        const dadosTecnicoManual = (item.dados_tecnico_sem_cadastro || '').trim()

        return {
          id: item?.id || null,
          ctrl_tecnico_id: tecnicoManual
            ? null
            : item.ctrl_tecnico_id,
          dados_tecnico_sem_cadastro: tecnicoManual
            ? dadosTecnicoManual
            : null,
          observacao: item.observacao
        }
      })

      const payload = {
        ctrl_tecnicos: listaTecnicos,
        pco_workflow_id: this.pcoWorkflowId,
        pco_tarefa_id: this.$route.params.pco_tarefa_id
      }

      await this.vincularTecnicos(payload)
      await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);
      await this.buscarHistoricoTicket(this.pcoWorkflowId);
      await this.carregarTecnicosVinculados();
    },

    informarTecnicoManual(item) {
      item.ctrl_tecnico_id = null
      item.ctrlTecnico = null
      item.tecnicoManual = true
    },

    selecionarTecnicoCadastrado(item) {
      item.dados_tecnico_sem_cadastro = ''
      item.tecnicoManual = false
    },

    buscarDadosTecnico(ctrlTecnicoId, item) {
      if (!ctrlTecnicoId) {
        item.ctrlTecnico = null
        return
      }

      item.ctrlTecnico = this.listaDeTecnicos.find(
        tecnico => tecnico.id === ctrlTecnicoId
      ) || null
    },

  },

  computed: {
    ...mapGetters('ctrlTecnicos', [
      'listaDeTecnicos',
      'loadingCtrlTecnicos'
    ]),

    ...mapGetters('fichaTecnicaWorkflow', [
      'loadingFichaTecnica'
    ])
  }
}
</script>

<style scoped>
.tecnico-card-body {
  line-height: 0.5;
}

.tecnico-dados-titulo {
  margin-bottom: 12px;
  color: #343a40;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
}

.tecnico-opcao-trigger {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 72px;
  padding: 12px 16px;
  border: 1px solid;
  border-radius: 6px;
  color: #343a40;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.tecnico-opcao-trigger:focus-visible {
  outline: 2px solid #e92332;
  outline-offset: 2px;
}

.tecnico-opcao-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  margin-right: 14px;
  border-radius: 50%;
}

.tecnico-opcao-icon svg {
  width: 23px;
  height: 23px;
}

.tecnico-opcao-text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
}

.tecnico-opcao-text strong {
  font-size: 15px;
  font-weight: 600;
}

.tecnico-opcao-text small {
  color: #6c757d;
  font-size: 13px;
}

.tecnico-opcao-chevron {
  margin-left: 12px;
  color: #6c757d;
  font-size: 28px;
  line-height: 1;
}

.tecnico-manual-trigger {
  border-color: #f5c6cb;
  background-color: #fff8f8;
}

.tecnico-manual-trigger:hover {
  border-color: #e9a5ac;
  background-color: #fff0f1;
}

.tecnico-manual-icon {
  background-color: #fde7e9;
  color: #e92332;
}

.tecnico-cadastrado-trigger {
  border-color: #cfe2ff;
  background-color: #f5f9ff;
}

.tecnico-cadastrado-trigger:hover {
  border-color: #a9ccf5;
  background-color: #eaf3ff;
}

.tecnico-cadastrado-icon {
  background-color: #dcecff;
  color: #356da8;
}
</style>